import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isMainModalOpen: false,
  activeMode: null, // 'post' | 'image' | 'video' | 'document' | 'article'
  mediaModalOpen: false,
  articleModalOpen: false,
  content: '',
  title: '',
  tags: [],
  visibility: 'PUBLIC', // Default visibility
  media: {
    images: [],
    video: null,
    document: null
  },
  article: {
    title: '',
    content: '',
    images: []
  },
  isPosting: false,
  postError: null,
  draftId: null,
  isDraftSaving: false,
  draftError: null,
   pendingNewPost: null,
   isPostingInProgress: false,  // ✅ add
apiDone: false,              // ✅ add
apiFailed: false, 
};

const communityCreatePostSlice = createSlice({
  name: 'communityCreatePost',
  initialState,
  reducers: {
    openMainModal: (state, action) => {
      state.isMainModalOpen = true;
      state.activeMode = action.payload || 'post';
    },
  closeMainModal: (state) => {
  // ✅ Reset everything on close
  state.isMainModalOpen = false;
  state.activeMode = null;
  state.mediaModalOpen = false;
  state.articleModalOpen = false;
  state.content = initialState.content;
  state.title = initialState.title;
  state.tags = initialState.tags;
  state.visibility = initialState.visibility;
  state.media = initialState.media;
  state.article = initialState.article;
  state.isPosting = false;
  state.postError = null;
  state.draftId = null;
  state.isDraftSaving = false;
  state.draftError = null;
},
    setActiveMode: (state, action) => {
      state.activeMode = action.payload;
    },
    openMediaModal: (state) => {
      state.mediaModalOpen = true;
    },
    closeMediaModal: (state) => {
      state.mediaModalOpen = false;
    },
    openArticleModal: (state) => {
      state.articleModalOpen = true;
    },
    closeArticleModal: (state) => {
      state.articleModalOpen = false;
    },
    setContent: (state, action) => {
      state.content = action.payload;
    },
    setTitle: (state, action) => {
      state.title = action.payload;
    },
    addTag: (state, action) => {
      if (!state.tags.includes(action.payload)) {
        state.tags.push(action.payload);
      }
    },
    removeTag: (state, action) => {
      state.tags = state.tags.filter(tag => tag !== action.payload);
    },
    clearTags: (state) => {
      state.tags = [];
    },
    addImage: (state, action) => {
      state.media.images.push(action.payload);
    },
    removeImage: (state, action) => {
      state.media.images = state.media.images.filter((_, index) => index !== action.payload);
    },
    reorderImages: (state, action) => {
      const { oldIndex, newIndex } = action.payload;
      const [removed] = state.media.images.splice(oldIndex, 1);
      state.media.images.splice(newIndex, 0, removed);
    },
    setVideo: (state, action) => {
      state.media.video = action.payload;
    },
    removeVideo: (state) => {
      state.media.video = null;
    },
    setDocument: (state, action) => {
      state.media.document = action.payload;
    },
    removeDocument: (state) => {
      state.media.document = null;
    },
    setArticleTitle: (state, action) => {
      state.article.title = action.payload;
    },
    setArticleContent: (state, action) => {
      state.article.content = action.payload;
    },
    addArticleImage: (state, action) => {
      state.article.images.push(action.payload);
    },
    removeArticleImage: (state, action) => {
      state.article.images = state.article.images.filter((_, index) => index !== action.payload);
    },
    reorderArticleImages: (state, action) => {
      const { oldIndex, newIndex } = action.payload;
      const [movedImage] = state.article.images.splice(oldIndex, 1);
      state.article.images.splice(newIndex, 0, movedImage);
    },
    setPosting: (state, action) => {
      state.isPosting = action.payload;
    },
    setPostError: (state, action) => {
      state.postError = action.payload;
    },
    setVisibility: (state, action) => {
      state.visibility = action.payload;
    },
  
    resetPostState: (state) => {
      // Reset all properties to initial state
      state.isMainModalOpen = initialState.isMainModalOpen;
      state.activeMode = initialState.activeMode;
      state.mediaModalOpen = initialState.mediaModalOpen;
      state.articleModalOpen = initialState.articleModalOpen;
      state.content = initialState.content;
      state.title = initialState.title;
      state.tags = initialState.tags;
      state.visibility = initialState.visibility;
      state.media = initialState.media;
      state.article = initialState.article;
      state.isPosting = initialState.isPosting;
      state.postError = initialState.postError;
      state.draftId = initialState.draftId;
      state.isDraftSaving = initialState.isDraftSaving;
      state.draftError = initialState.draftError;
    },
    resetMedia: (state) => {
      state.media = {
        images: [],
        video: null,
        document: null
      };
    },
    resetArticle: (state) => {
      state.article = {
        title: '',
        content: '',
        images: []
      };
    },
      setPendingNewPost: (state, action) => {
  state.pendingNewPost = action.payload;
},
clearPendingNewPost: (state) => {
  state.pendingNewPost = null;
},
setPostingProgress: (state, action) => {
  state.isPostingInProgress = action.payload.isPostingInProgress ?? state.isPostingInProgress;
  state.apiDone = action.payload.apiDone ?? state.apiDone;
  state.apiFailed = action.payload.apiFailed ?? state.apiFailed;
}

  }
});

export const {
  openMainModal,
  closeMainModal,
  setActiveMode,
  openMediaModal,
  closeMediaModal,
  openArticleModal,
  closeArticleModal,
  setContent,
  setTitle,
  addTag,
  removeTag,
  clearTags,
  addImage,
  removeImage,
  reorderImages,
  setVideo,
  removeVideo,
  setDocument,
  removeDocument,
  setArticleTitle,
  setArticleContent,
  addArticleImage,
  removeArticleImage,
  reorderArticleImages,
  setPosting,
  setPostError,
  setVisibility,
  setDraftId,
  setDraftSaving,
  setDraftError,
  resetPostState,
  resetMedia,
  resetArticle,
  setPendingNewPost,
  clearPendingNewPost,
  setPostingProgress 
} = communityCreatePostSlice.actions;

export default communityCreatePostSlice.reducer;
